export default __webpack_public_path__ + "static/media/53.d27e6f9e.png";